// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-Idn","rootNoMargin":"styles_rootNoMargin__7EuI2"};